import '../../core/components/app-root/AppRoot.css';
import '../code-snippet/CodeHighlight.css';
import '../code-snippet/CodeSnippet.css';
import './AiResponse.css';
export var streamdown = '_jdyvf81-3-12-1';
export var wrapper = '_jdyvf80-3-12-1';